/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Faq_A1Inputs */

const en_directory_home_faq_a1 = /** @type {(inputs: Directory_Home_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI is a curated directory of the best AI tools for every job — writing, video, code, and design. Each listing is scored by independent AI agents across six dimensions, with pricing verified weekly and alternatives compared side by side.`)
};

const zh_directory_home_faq_a1 = /** @type {(inputs: Directory_Home_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 是一个严选 AI 工具目录——写作、视频、代码、设计，每个任务都能找到最好的工具。每条收录由独立 AI 智能体按六个维度评分，定价每周核实，替代方案并排对比。`)
};

/**
* | output |
* | --- |
* | "Seek AI is a curated directory of the best AI tools for every job — writing, video, code, and design. Each listing is scored by independent AI agents across ..." |
*
* @param {Directory_Home_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_faq_a1 = /** @type {((inputs?: Directory_Home_Faq_A1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Faq_A1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_faq_a1(inputs)
	return zh_directory_home_faq_a1(inputs)
});
export { directory_home_faq_a1 as "directory.home.faq.a1" }